import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { goToCheckout } from '../constants/checkout';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  const [selectedPlan, setSelectedPlan] = useState<'base' | 'pro'>('pro');
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <section id="pricing" className="py-16 px-5 bg-wine text-white" data-id="element-130">
      <div className="max-w-md mx-auto" data-id="element-131">
        <div className="text-center mb-8" data-id="element-132">
          <p className="text-pink-pastel font-bold text-sm tracking-widest uppercase mb-3" data-id="element-133">
            Esta oferta termina en
          </p>
          <div className="flex justify-center gap-3" data-id="element-134">
            <div className="bg-wine-dark rounded-xl p-3 w-20 shadow-inner border border-white/5" data-id="element-135">
              <div className="text-3xl font-bold tabular-nums" data-id="element-136">
                {formatTime(timeLeft.hours)}
              </div>
              <div className="text-[10px] text-white/50 uppercase tracking-wider mt-1" data-id="element-137">
                Horas
              </div>
            </div>
            <div className="text-3xl font-bold text-white/30 self-start mt-2" data-id="element-138">
              :
            </div>
            <div className="bg-wine-dark rounded-xl p-3 w-20 shadow-inner border border-white/5" data-id="element-139">
              <div className="text-3xl font-bold tabular-nums" data-id="element-140">
                {formatTime(timeLeft.minutes)}
              </div>
              <div className="text-[10px] text-white/50 uppercase tracking-wider mt-1" data-id="element-141">
                Min
              </div>
            </div>
            <div className="text-3xl font-bold text-white/30 self-start mt-2" data-id="element-142">
              :
            </div>
            <div className="bg-wine-dark rounded-xl p-3 w-20 shadow-inner border border-white/5" data-id="element-143">
              <div className="text-3xl font-bold tabular-nums" data-id="element-144">
                {formatTime(timeLeft.seconds)}
              </div>
              <div className="text-[10px] text-white/50 uppercase tracking-wider mt-1" data-id="element-145">
                Seg
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mb-8" data-id="element-146">
          <h2 className="text-3xl font-extrabold mb-2" data-id="element-147">
            ELEGÍ TU DECORA FÁCIL PRO
          </h2>
          <p className="text-pink-pastel text-sm" data-id="element-148">
            Ambas opciones incluyen los 6 tomos completos
          </p>
        </div>

        <div className="flex flex-col gap-4 mb-8" data-id="element-149">
          {/* Plan Base */}
          <label className={`relative flex items-start gap-4 p-5 rounded-2xl cursor-pointer transition-all ${selectedPlan === 'base' ? 'bg-wine-dark border-2 border-white/20' : 'bg-white/5 border border-white/10'}`} data-id="element-150">
            <div className="mt-1 shrink-0" data-id="element-151">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'base' ? 'border-gold' : 'border-white/30'}`} data-id="element-152">
                {selectedPlan === 'base' && <div className="w-2.5 h-2.5 bg-gold rounded-full" data-id="element-153" />}
              </div>
            </div>
            <div className="flex-1" data-id="element-154">
              <div className="flex justify-between items-start mb-1" data-id="element-155">
                <h3 className="font-bold text-lg" data-id="element-156">🎀 DECORA FÁCIL</h3>
                <div className="text-right" data-id="element-157">
                  <div className="text-xs text-white/50 line-through" data-id="element-158">
                    $45.000
                  </div>
                  <div className="font-bold text-xl" data-id="element-159">$18.990</div>
                </div>
              </div>
              <p className="text-sm text-white/70" data-id="element-160">6 tomos + 4 bonos base</p>
            </div>
            <input type="radio" name="plan" value="base" checked={selectedPlan === 'base'} onChange={() => setSelectedPlan('base')} className="hidden" data-id="element-161" />
          </label>

          {/* Plan PRO */}
          <label className={`relative flex items-start gap-4 p-5 rounded-2xl cursor-pointer transition-all ${selectedPlan === 'pro' ? 'bg-wine-dark border-2 border-gold shadow-[0_0_20px_rgba(201,162,76,0.15)]' : 'bg-white/5 border border-white/10'}`} data-id="element-162">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 flex gap-2" data-id="element-163">
              <span className="bg-gold text-wine text-[10px] font-bold px-2 py-1 rounded-full uppercase tracking-wider whitespace-nowrap shadow-sm" data-id="element-164">
                ⭐ Más Elegido
              </span>
              <span className="bg-sage text-white text-[10px] font-bold px-2 py-1 rounded-full uppercase tracking-wider whitespace-nowrap shadow-sm" data-id="element-165">
                Ahorrás $38.000
              </span>
            </div>

            <div className="mt-2 shrink-0" data-id="element-166">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'pro' ? 'border-gold' : 'border-white/30'}`} data-id="element-167">
                {selectedPlan === 'pro' && <div className="w-2.5 h-2.5 bg-gold rounded-full" data-id="element-168" />}
              </div>
            </div>
            <div className="flex-1 mt-1" data-id="element-169">
              <div className="flex justify-between items-start mb-1" data-id="element-170">
                <h3 className="font-bold text-lg text-gold" data-id="element-171">
                  ⭐ PLAN PRO/ÉLITE
                </h3>
                <div className="text-right" data-id="element-172">
                  <div className="text-xs text-white/50 line-through" data-id="element-173">
                    $65.000
                  </div>
                  <div className="font-bold text-xl text-gold" data-id="element-174">$26.990</div>
                </div>
              </div>
              <p className="text-sm text-white/80" data-id="element-175">
                6 tomos + 4 bonos base{' '}
                <span className="font-bold text-gold" data-id="element-176">+ 3 bonos PRO</span>
              </p>
            </div>
            <input type="radio" name="plan" value="pro" checked={selectedPlan === 'pro'} onChange={() => setSelectedPlan('pro')} className="hidden" data-id="element-177" />
          </label>
        </div>

        <button onClick={() => goToCheckout(selectedPlan)} className="w-full h-[56px] bg-gold text-wine rounded-xl font-extrabold text-lg flex items-center justify-center gap-2 shadow-lg shadow-gold/20 active:scale-[0.98] transition-transform mb-3" data-id="element-178">
          SÍ, QUIERO EL PLAN {selectedPlan === 'pro' ? 'PRO/ÉLITE' : 'BASE'}{' '}
          <ArrowRight className="w-5 h-5" data-id="element-179" />
        </button>
        <p className="text-center text-xs text-white/50 mb-8" data-id="element-180">
          {selectedPlan === 'pro' ? 'La opción más elegida por quienes quieren vivir de esto' : 'Ideal para arrancar a decorar y cobrar'}
        </p>

        <div className="flex justify-center items-center gap-4 text-xs font-medium text-white/70" data-id="element-181">
          <div className="flex items-center gap-1" data-id="element-182">🔒 Pago seguro</div>
          <div className="w-1 h-1 bg-white/30 rounded-full" data-id="element-183" />
          <div className="flex items-center gap-1" data-id="element-184">⚡ Acceso inmediato</div>
          <div className="w-1 h-1 bg-white/30 rounded-full" data-id="element-185" />
          <div className="flex items-center gap-1" data-id="element-186">🛡️ Garantía 7 días</div>
        </div>
      </div>
    </section>;
}